.content {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  box-sizing: border-box;
  padding-block: 20px;
  padding-inline: 40px;
  height: 100%;
  overflow-y: auto;
  background-color: #fbfcff;
  border-radius: 8px;
  gap: 50px;
}

.text_content{
  width: 500px;
}

.content_title {
  font-family: var(--font-family-header);
  font-size: var(--font-size-3xl);
  font-weight: bold;
  color: var(--color-text-dark);
  margin-bottom: 15px;
  letter-spacing: 0.02em;
}

.content_image {
  flex: 1 1 0;
  width: 0;
  max-width: 100%;
  object-fit: cover;
  border-radius: 8px;
  margin-bottom: 15px;
  flex-shrink: 1;
  box-shadow:
    0 18px 45px rgba(15, 23, 42, 0.14),
    0 2px 8px rgba(15, 23, 42, 0.08);
}

.content_description {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  line-height: 1.6;
  margin-bottom: 20px;
}

.content_display_name {
  font-size: var(--font-size-md);
  font-style: italic;
  line-height: 1.6;
  color: #837f7f;
  margin: 0;
}

@media screen and (max-width: 768px) {
  .content_title {
    font-size: 30px;
  }

  .content_description {
    margin-top: 30px;
  }
}
